import {ACTION_CODE} from './_actionCode';
import {TrainingProductOriginService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'UPDATE_TRAINING_PRODUCTORIGIN';

export async function updateTrainingProductOrigin(
    userData: Record<string, string>,
    id: number,
    updatedTrainingProductOrigin: Record<string, any>,
) {
    try {

        LoggerService.logInfo('Action - updateTrainingProductOrigin - Start');

        const updateTrainingProductOriginResult = await TrainingProductOriginService.updateTrainingProductOrigin(userData, id, updatedTrainingProductOrigin);

        LoggerService.logInfo('Action - updateTrainingProductOrigin - End - Success');

        return ResultModel.newSuccessResult(updateTrainingProductOriginResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateTrainingProductOrigin - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
